export function mapISOStringToDateString(date: string) {
  const { day, month, year } = getDateElements(date);
  return `${month}-${day}-${year}`;
}

function parseDateNumber(dateNumber: number) {
  const dateString = String(dateNumber);
  return dateString.length > 1 ? dateString : `0${dateString}`;
}

function getDateElements(date: string) {
  const dateObject = new Date(date);
  const year = dateObject.getFullYear();
  const month = parseDateNumber(dateObject.getMonth() + 1);
  const day = parseDateNumber(dateObject.getDate());

  return {
    day,
    month,
    year,
  };
}
